<div class="flex min-h-0 flex-1 flex-col">
    <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col" [class.disabled]="!isTableActive" *ngIf="!isLoading; else tableShimmer">
        <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
            <h3 class="mb-0 mt-0">{{ 'ENGAGE.AUDIENCE.TITLE.SINGULAR' | translate }}</h3>

            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>

        <div class="audience-filter-container" fxLayout="column" fxLayoutAlign="start">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                <!-- This is the tree node template for leaf nodes -->
                <!-- There is inline padding applied to this node using styles.
              This padding value depends on the mat-icon-button width. -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <button class="mr-8" mat-icon-button>
                                <mat-icon class="circle">circle</mat-icon>
                            </button>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="audience-filter-name">
                                <h3 class="mb-0">{{ node.name | translate }}</h3>
                                <mat-icon
                                    *ngIf="hasBrokenAudienceFilter(node)"
                                    class="audience-filter-warning-icon"
                                    color="warn"
                                    matTooltip="{{ 'ENGAGE.AUDIENCE.TOOLTIPS.MISSING_FILTERS' | translate }}"
                                >
                                    warning
                                </mat-icon>
                            </div>
                        </div>

                        <app-flat-button
                            [label]="isSingleSelect ? 'GENERAL.BUTTON.SELECT' : 'GENERAL.BUTTON.ADD'"
                            (onClick)="addToList(node); onSelection()"
                            *ngIf="node.selectable !== false && (isSingleSelect ? !(selectedNode && selectedNode.id == node.id) : !node.isSelected); else selected"
                            [disabled]="hasBrokenAudienceFilter(node) || (selectedNode && selectedNode.id !== node.id && isSingleSelect)"
                        ></app-flat-button>
                        <ng-template #selected>
                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node); onSelection()"></app-white-button>
                        </ng-template>
                    </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-12 pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <button mat-icon-button class="mr-8" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" (click)="onNodeToggle(node)">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{ expandedById[node.id] ? 'expand_more' : 'chevron_right' }}
                                </mat-icon>
                            </button>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" class="audience-filter-name">
                                <h3 class="mb-0">{{ node.name | translate }}</h3>
                                <mat-icon
                                    *ngIf="hasBrokenAudienceFilter(node)"
                                    class="audience-filter-warning-icon"
                                    color="warn"
                                    matTooltip="{{ 'ENGAGE.AUDIENCE.TOOLTIPS.MISSING_FILTERS' | translate }}"
                                >
                                    warning
                                </mat-icon>
                            </div>
                        </div>

                        <app-flat-button
                            [label]="isSingleSelect ? 'GENERAL.BUTTON.SELECT' : 'GENERAL.BUTTON.ADD'"
                            (onClick)="addToList(node); onSelection()"
                            *ngIf="node.selectable !== false && (isSingleSelect ? !(selectedNode && selectedNode.id == node.id) : !node.isSelected); else selectedNested"
                            [disabled]="hasBrokenAudienceFilter(node) || (selectedNode && selectedNode.id !== node.id && isSingleSelect) || (!node.parent && isSingleSelect)"
                        ></app-flat-button>
                        <ng-template #selectedNested>
                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node); onSelection()"></app-white-button>
                        </ng-template>
                    </div>
                    <!-- There is inline padding applied to this div using styles.
                    This padding value depends on the mat-icon-button width.  -->
                    <div [class.example-tree-invisible]="!expandedById[node.id]" role="group">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </div>
    </div>

    <mat-checkbox class="mt-16 shrink-0" [(ngModel)]="isUnassignedSelected" (change)="onSelection()" *ngIf="!isLoading && showNotAssiggnedUsersControl">
        {{ 'GENERAL.LABEL.UNASSIGNED_AUDIENCE' | translate }}
    </mat-checkbox>
</div>

<ng-template #tableShimmer>
    <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
        <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
            <h3 class="mb-0 mt-0">{{ 'ENGAGE.AUDIENCE.TITLE.SINGULAR' | translate }}</h3>
        </div>
        <div class="audience-filter-container filter-table-shimmer">
            <div class="shimmer-container py-16 px-16">
                <div class="shimmer" *ngFor="let item of [1, 2, 3, 4, 5]">
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                        <div class="shimmer-title w-100-p animate mb-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
